import { AuthError } from '@src/shared/helpers/auth';

export interface AuthErrorMessageProps {
    error: string | AuthError;
}

export const AuthErrorMessage = ({ error }: AuthErrorMessageProps) => {
    if (typeof error === 'string') {
        return <p>{error}</p>;
    }

    return (
        <p>
            {error.message}
            {error.link && (
                <a
                    className='underline'
                    href={error.link.href}
                    target='_self'
                    rel='noopener noreferrer'
                    data-track-event={error.link.trackEvent}
                >
                    {error.link.text}
                </a>
            )}
        </p>
    );
};
